module.exports = __webpack_public_path__ + "13e80be0336eab3f1ab67dc952fc4e45.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-7.png
// module id = 1447
// module chunks = 0